import { Phone, Mail, MapPin } from 'lucide-react';
import { LOGO_BASE64 } from '../utils/logoData';

const LOGO_URL = LOGO_BASE64;

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 lg:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src={LOGO_URL} 
                alt="郑州博乐" 
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              专注于企业物流信息化解决方案，为水泥、建材等行业提供智能化船运发货管理系统。
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-slate-400">
                <Phone className="w-4 h-4 text-ocean-400" />
                <a href="tel:0371-65862867" className="text-sm hover:text-ocean-300 transition-colors">0371-65862867</a>
              </div>
              <div className="flex items-center gap-3 text-slate-400">
                <Phone className="w-4 h-4 text-ocean-400" />
                <a href="tel:13007504285" className="text-sm hover:text-ocean-300 transition-colors">13007504285</a>
              </div>
              <div className="flex items-center gap-3 text-slate-400">
                <Mail className="w-4 h-4 text-ocean-400" />
                <span className="text-sm">bolesoft@qq.com</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400">
                <MapPin className="w-4 h-4 text-ocean-400" />
                <span className="text-sm">郑州市高新区瑞达路96号</span>
              </div>
            </div>
          </div>

          {/* Product Modules */}
          <div>
            <h3 className="font-semibold text-white mb-4">产品模块</h3>
            <ul className="space-y-3">
              {['派单平台', '船运调度系统', '船运计量系统', '自助审核打印', '管理驾驶舱'].map((item) => (
                <li key={item}>
                  <a href="#products" className="text-slate-400 hover:text-ocean-400 text-sm transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Application Scenarios */}
          <div>
            <h3 className="font-semibold text-white mb-4">应用场景</h3>
            <ul className="space-y-3">
              {['水泥船运发货', '砂石船运发货', '骨料船运发货', '煤炭船运发货', '粮食船运发货'].map((item) => (
                <li key={item}>
                  <a href="#scenarios" className="text-slate-400 hover:text-ocean-400 text-sm transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">快速链接</h3>
            <ul className="space-y-3">
              {['关于我们', '产品中心', '解决方案', '客户案例', '联系我们'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-slate-400 hover:text-ocean-400 text-sm transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © 2026 郑州博乐信息技术有限公司. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
                服务条款
              </a>
              <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
                网站地图
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
